import { createContext } from "react";
import { doNothing } from "@edgetier/utilities";

import { IModalContext } from "./context.types";

const ModalContext = createContext<IModalContext>({
    canClose: true,
    canDismiss: true,
    hideModal: doNothing,
    isOpen: false,
    showModal: doNothing,
    title: undefined,
    updateTitle: doNothing,
});

export default ModalContext;
